import { setCookie, parseCookies } from 'nookies'
import { useMutation, useQueryClient } from 'react-query'

import { EMAIL_STORAGE_KEY } from '~constants/storage.constants'
import { createEvaluation } from '~services/evaluations.service'

export const useCreateEvaluationMutation = () => {
  const queryClient = useQueryClient()

  return useMutation(createEvaluation, {
    onSuccess: (evaluation) => {
      queryClient.setQueryData(['evaluations', evaluation.email], evaluation)

      const cookies = parseCookies()
      if (cookies[EMAIL_STORAGE_KEY]) return

      setCookie(null, EMAIL_STORAGE_KEY, evaluation.email, {
        maxAge: 30 * 24 * 60 * 60,
        path: '/',
      })
    },
  })
}
